// extracted by mini-css-extract-plugin
export default {"miniCard":"miniTaskCard_miniCard__STpXI","heading":"miniTaskCard_heading__W9hla","taskTitle":"miniTaskCard_taskTitle__dFDtn"};